import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  MdList,
  MdPerson,
  MdHome,
  MdLock,
  MdSource,
  MdCheck,
  MdOutlineCancel,
  MdCancel,
  MdCompare,
  MdEventBusy,
  MdCardMembership,
  MdGroup,
  MdListAlt,
} from "react-icons/md";

// Admin Imports
import MainDashboard from "views/admin/default";
//import NFTMarketplace from "views/admin/marketplace";
// import Profile from "views/admin/profile";
// import DataTables from "views/admin/dataTables";
//import RTL from "views/admin/rtl";
import HistoryDataTables from "views/admin/historyDataTables";
import RawDataTables from "views/admin/rawDataTables";
import BillOK from "views/admin/dataOkTables";
import BillCancel from "views/admin/dataCancelTables";
import BillCancelItem from "views/admin/dataCancelItemTables";
import CXM from "views/admin/dataCXMTables";
import EndOfDayTables from "views/admin/endOfDayDataTables";
import EODComparison from "views/admin/eodComparison";
import UserManagement from "views/admin/userManagement";
import RoleManagement from "views/admin/roleManagement";
import BranchManagement from "views/admin/branchManagement";
import PBData from "views/admin/pbDataTables";
import BackdateProcess from "views/admin/backdateProcess";

// Auth Imports
import SignInCentered from "views/auth/signIn";
import OtpCentered from "views/auth/otp";

import AuthChecking from "./authChecking"

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    icon: <Icon as={MdList} width="20px" height="20px" color="inherit" />,
    path: "/dashboard",
    component: MainDashboard,
    AuthRequired: false,
  },
  // {
  //   name: "Logs",
  //   layout: "/admin",
  //   icon: <Icon as={MdList} width="20px" height="20px" color="inherit" />,
  //   path: "/history-data-tables",
  //   component: HistoryDataTables,
  //   AuthRequired: false,
  // },
  // {
  //   name: "Raw Data",
  //   layout: "/admin",
  //   icon: <Icon as={MdSource} width="20px" height="20px" color="inherit" />,
  //   path: "/raw-data-tables",
  //   component: RawDataTables,
  //   AuthRequired: false,
  // },
  {
    name: "Bill OK",
    layout: "/admin",
    icon: <Icon as={MdCheck} width="20px" height="20px" color="inherit" />,
    path: "/bill-ok",
    component: BillOK,
    AuthRequired: false,
  },
  {
    name: "Bill Cancel",
    layout: "/admin",
    icon: <Icon as={MdCancel} width="20px" height="20px" color="inherit" />,
    path: "/bill-cancel",
    component: BillCancel,
    AuthRequired: false,
  },
  {
    name: "Bill Cancel Item",
    layout: "/admin",
    icon: (
      <Icon as={MdOutlineCancel} width="20px" height="20px" color="inherit" />
    ),
    path: "/bill-item-cancel",
    component: BillCancelItem,
    AuthRequired: false,
  },
  // {
  //   name: "CXM",
  //   layout: "/admin",
  //   icon: (
  //     <Icon as={MdCardMembership} width="20px" height="20px" color="inherit" />
  //   ),
  //   path: "/cxm-data",
  //   component: CXM,
  //   AuthRequired: false,
  // },
  {
    name: "End of Days",
    layout: "/admin",
    icon: <Icon as={MdEventBusy} width="20px" height="20px" color="inherit" />,
    path: "/end-of-day",
    component: EndOfDayTables,
    AuthRequired: false,
  },
  {
    name: "PB1 Data",
    layout: "/admin",
    icon: <Icon as={MdListAlt} width="20px" height="20px" color="inherit" />,
    path: "/pb1-data",
    component: PBData,
    AuthRequired: false,
  },
  {
    name: "Rebuild",
    layout: "/admin",
    icon: <Icon as={MdListAlt} width="20px" height="20px" color="inherit" />,
    path: "/rebuild",
    component: BackdateProcess,
    AuthRequired: false,
  },
  // {
  //   name: "EOD Comparison",
  //   layout: "/admin",
  //   icon: <Icon as={MdCompare} width="20px" height="20px" color="inherit" />,
  //   path: "/eod-comparison",
  //   component: EODComparison,
  //   AuthRequired: false,
  // },
  {
    name: "User Management",
    layout: "/admin",
    icon: <Icon as={MdGroup} width="20px" height="20px" color="inherit" />,
    path: "/user-management",
    component: UserManagement,
    AuthRequired: false,
  },
  {
    name: "Role Management",
    layout: "/admin",
    icon: <Icon as={MdGroup} width="20px" height="20px" color="inherit" />,
    path: "/role-management",
    component: RoleManagement,
    AuthRequired: false,
  },
  {
    name: "Branch Management",
    layout: "/admin",
    icon: <Icon as={MdGroup} width="20px" height="20px" color="inherit" />,
    path: "/branch-management",
    component: BranchManagement,
    AuthRequired: false,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: SignInCentered,
    AuthRequired: false,
  },

  {
    name: "OTP",
    layout: "/auth",
    path: "/otp",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: OtpCentered,
    AuthRequired: false,
  },
];

export default routes;
